import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Deletes a blocked slot by id and invalidates the blocked-slots query cache. */
export function useDeleteBlockedSlot() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await api.delete('/blocked-slots/:id', { params: { id } })
      if (!response.success) {
        throw new Error(response.error.message)
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blocked-slots'] })
    },
  })
}
